import {
  Header,
  SearchFilterWrapper,
  setDateFromStorage,
  HeaderFilterContainer,
  TypeSelectorAndSearch,
  SearchSelectResponsive,
  useTranslation
} from '@fareye/common'
import { IKeyValue, IDateRange } from '@fareye/types'
import { DatePicker, Flex, SearchSelect, Span } from '@fareye/ui'
import {
  dMmm,
  getQueryParams,
  getSearchFilterFromSession,
  yyyyMmDd,
  snakeCase,
  MdFilterList
} from '@fareye/utils'
import queryString, { ParsedQuery } from 'query-string'
import React from 'react'
import { mapping } from '../../../config/mapComponents'
import { SHIPMENT_TYPES } from '../../../config/constants'
import SummaryFilter from '../../../components/SummaryV2'
import { SummarFilterWrapper, MoreFilterButton } from '../../../style/styled'
import {
  ISelectedSummaryFilter,
  ISelectedMoreFilter
} from '../../../utility/types'
import { AddFiltersListing } from '../../../components/MoreFilters/AddFiltersListing'
import { inTransitConstant } from '../../../config/constants'

export function MultiModelListing({
  match,
  config,
  history,
  location,
  maxRefreshCount,
  refreshInterval,
  routesConfig
}: any) {
  const searchParams: ParsedQuery<string | Date> = queryString.parse(
    location.search
  )
  const {
    carryDate,
    showDatePicker,
    showTimezone,
    showSummary,
    showMoreFilters = true,
    toggleContent,
    pageType,
    additionalDays = 0,
    minDaysInMonth
  } = config.config
  const { t } = useTranslation()
  let pageHeaderType: any = pageType ? pageType : SHIPMENT_TYPES
  const { children, styling, globalSearchPageId, filters } = config
  const { style, className, bodyBgColor, variant, layoutStyle } = styling
  const [globalSearch, setGlobalSearch] = React.useState(
    getSearchFilterFromSession(globalSearchPageId)
  )
  const inititalSelectedSummaryFilter = {
    selectedFilters: {},
    numberOfFiltersApplied: 0
  }
  const [selectedSummaryFilter, setSelectedSummaryFilter] = React.useState<
    ISelectedSummaryFilter
  >(inititalSelectedSummaryFilter)
  const [selectedMoreFilter, setSelectedMoreFilter] = React.useState<
    ISelectedMoreFilter
  >({
    selectedFilters: {}
  })
  const [showMoreFiltersModal, setShowMoreFiltersModal] = React.useState(false)
  const [summaryData, setSummaryData] = React.useState({})

  const filterSelectedKey = toggleContent
    ? toggleContent.filter((item: any) =>
        item.link ? item.link === match.path : true
      )
    : []
  const [selectedKey, setSelectedKey] = React.useState(
    filterSelectedKey.length ? filterSelectedKey[0].selectedKey : ''
  )

  const [lastUpdate, setLastUpdate] = React.useState<string>('')
  const [dateRange, setDateRange] = React.useState(() => {
    return setDateFromStorage({
      showDatePicker: !!showDatePicker,
      carryDate,
      searchParams,
      daysDiff: 20
    })
  })

  const [selectedShipmentType, setSelectedShipmentType] = React.useState(
    pageHeaderType[0]
  )
  const { startDate, endDate } = dateRange as IDateRange<Date>

  React.useEffect(() => {
    if (showDatePicker) {
      let prevStartDate = searchParams.startDate
      let prevEndDate = searchParams.endDate
      if (prevStartDate !== startDate || prevEndDate !== endDate) {
        const queryParams = getQueryParams({
          ...queryString.parse(location.search),
          startDate,
          endDate
        })
        history.replace({
          pathname: match.url,
          search: queryParams
        })
      }
    }
  }, [dateRange])

  function setDateRangeAndStorage(dates: IDateRange<string | Date>) {
    localStorage.setItem('date', JSON.stringify(dates))
    setDateRange(dates as IDateRange<Date>)
  }

  const fileName = (match.params && (match.params as any).id) || 'InTransit'
  const { component } = config.children[selectedShipmentType.value]
  const ComponentRender = (mapping as any)[component]

  const apiFilter = React.useMemo(() => {
    let filterConfig = config?.filters?.apiFilter
    filterConfig.queryParams.data_source = selectedShipmentType.dataSource

    let selectedTypeConfig = config.children[selectedShipmentType.value]?.config?.apiConfig
    if (selectedTypeConfig?.queryParams) {
      delete filterConfig.queryParams.is_active 
      delete filterConfig.queryParams.active_status 
      Object.values(selectedTypeConfig.queryParams).forEach((param: any) => {
        if (param.filterKey && param.filterValue !== undefined) {
          filterConfig.queryParams[param.filterKey] = param.filterValue;
        }
      })
    }
    return filterConfig
  }, [selectedShipmentType])

  let translatedSelectedShipmentType = { ...selectedShipmentType }
  translatedSelectedShipmentType.label = t(translatedSelectedShipmentType.label)
  let maxDate = new Date()
  maxDate.setDate(maxDate.getDate() + additionalDays)
  const selectedAggsFilter = React.useMemo(() => {
    return {
      ...selectedMoreFilter.selectedFilters,
      ...selectedSummaryFilter.selectedFilters
    }
  }, [selectedMoreFilter, selectedSummaryFilter])
  return (
    <>
      <Flex column style={{ ...layoutStyle, height: '100%' }}>
        <Header
          match={match}
          toggle={toggleContent}
          lastUpdate={lastUpdate}
          selectedKey={selectedKey}
          setSelectedKey={setSelectedKey}
          startDate={startDate}
          endDate={endDate}
          location={location}
          history={history}
          routesConfig={routesConfig}
          rightTopCorner={
            showDatePicker ? (
              <Flex>
                <DatePicker
                  variant="fareyeV2"
                  formatter={yyyyMmDd}
                  onDateRangeSelected={setDateRangeAndStorage}
                  value={dateRange}
                  maxDate={maxDate}
                  minDaysInMonth={minDaysInMonth}
                />
              </Flex>
            ) : null
          }
          showTimezone={showTimezone}
        >
          <HeaderFilterContainer>
            <TypeSelectorAndSearch>
              <SearchFilterWrapper
                apiFilter={apiFilter}
                customKeyMapping={(config.filters as any)?.customKeyMapping}
                apiFav={config?.filters?.apiFav}
                pageId="intransit"
                search={globalSearch}
                setSearch={setGlobalSearch}
                summaryKeys={Object.keys(summaryData).map((key: any) =>
                  snakeCase(key)
                )}
                startDate={startDate}
                endDate={endDate}
                showTimezone={showTimezone}
              >
                <SearchSelectResponsive>
                  <SearchSelect
                    options={pageHeaderType || []}
                    value={selectedShipmentType}
                    placeholder={t('Select Shipment Type')}
                    onChange={(item: any) => {
                      setSelectedShipmentType(item)
                      setSelectedSummaryFilter(inititalSelectedSummaryFilter)
                      setSelectedMoreFilter({
                        ...selectedMoreFilter,
                        selectedFilters: {}
                      })
                    }}
                    t={t}
                    style={{
                      container: {
                        width: '100%',
                        margin: '1px 8px 1px 1px',
                        borderRadius: '0px'
                      },
                      wrapper: {
                        width: '100%',
                        alignItems: 'flex-start'
                      },
                      control: {
                        height: '46px'
                      },
                      dropdownIndicator: {
                        display: 'block',
                        transform: 'rotate(0deg) !important'
                      }
                    }}
                  />
                </SearchSelectResponsive>
              </SearchFilterWrapper>
            </TypeSelectorAndSearch>
            <Flex>
              {showSummary ? (
                <SummarFilterWrapper>
                  <SummaryFilter
                    selectedSummaryFilter={selectedSummaryFilter}
                    setSelectedSummaryFilter={setSelectedSummaryFilter}
                    summaryData={Object.fromEntries(
                      Object.entries(summaryData).filter(([key]) =>
                        ['status', 'transport_mode'].includes(key)
                      )
                    )}
                  />
                </SummarFilterWrapper>
              ) : null}
              <Flex justifyContentFlexEnd style={{ flex: '1 1 auto' }}>
                <MoreFilterButton
                  onClick={() => setShowMoreFiltersModal(true)}
                  leftChild={
                    <MdFilterList
                      style={{
                        width: '16px',
                        height: '16px',
                        left: '-1px',
                        top: '-1px',
                        color: '#1276D3'
                      }}
                    />
                  }
                >
                  <Span
                    variant="h6"
                    style={{
                      color: '#1276D3'
                    }}
                  >
                    {t(inTransitConstant['moreFilters'])}
                  </Span>
                </MoreFilterButton>
              </Flex>
            </Flex>
          </HeaderFilterContainer>
        </Header>
        <div style={{ flexGrow: 1, background: bodyBgColor }}>
          <div
            style={{
              flexGrow: 1,
              background: bodyBgColor,
              padding: '10px 15px 50px'
            }}
          >
            <ComponentRender
              key={selectedShipmentType.value}
              match={match}
              fileName={`${fileName}_${dMmm()}`}
              history={history}
              mapping={mapping}
              location={location}
              type={selectedShipmentType}
              maxRefreshCount={maxRefreshCount}
              refreshInterval={refreshInterval}
              selectedKey={selectedKey}
              setLastUpdate={setLastUpdate}
              endDate={showDatePicker ? endDate : null}
              startDate={showDatePicker ? startDate : null}
              showDatePicker={showDatePicker}
              config={config.children[selectedShipmentType.value]}
              globalSearch={globalSearch}
              showTimezone={showTimezone}
              setSummaryData={setSummaryData}
              selectedFilters={selectedMoreFilter}
              setSelectedFilters={setSelectedMoreFilter}
              selectedAggsFilter={selectedAggsFilter}
            />
          </div>
        </div>
      </Flex>
      {showMoreFilters && (
        <AddFiltersListing
          selectedMoreFilter={selectedMoreFilter}
          setSelectedMoreFilter={setSelectedMoreFilter}
          showMoreFiltersModal={showMoreFiltersModal}
          setShowMoreFiltersModal={setShowMoreFiltersModal}
          moreFilterOptions={Object.fromEntries(
            Object.entries(summaryData).filter(
              ([key]) => !['status', 'transport_mode'].includes(key)
            )
          )}
          globalSearch={globalSearch}
        />
      )}
    </>
  )
}
